import { PageNumber, PageSize } from "@redriver/cinnamon-mui";
import { Stack } from "@mui/material";
import ResultsCounter from "./ResultsCounter";

const TablePagination = ({ value, onChange, totalItems, fixedPageSize }) => {
  const onNumberChange = (pageNumber) => {
    onChange({
      pageSize: value.pageSize,
      pageNumber,
    });
  };

  const onSizeChange = (pageSize) => {
    // ensure page number still valid
    const totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 0;
    onChange({
      pageSize,
      pageNumber: Math.min(totalPages || 1, value.pageNumber || 1),
    });
  };

  return (
    <Stack
      className="table-pagination"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <ResultsCounter
        pageNumber={value.pageNumber}
        pageSize={value.pageSize}
        totalItems={totalItems}
      />
      <PageNumber
        value={value.pageNumber}
        onChange={onNumberChange}
        pageSize={value.pageSize}
        totalItems={totalItems}
        color="primary"
      />
      {!fixedPageSize && (
        <PageSize
          value={value.pageSize}
          onChange={onSizeChange}
          options={[10, 25, 50, 100]}
          size="small"
        />
      )}
    </Stack>
  );
};

export default TablePagination;
